import { faqItems } from "../../content/faq";

export function FAQ() {
  return (
    <section
      id="faq"
      className="faq section section--compact"
      data-review-region="mandatory-faq"
      aria-labelledby="faq-title"
    >
      <div className="section-shell faq__layout">
        <div className="section-intro faq__intro">
          <p className="section-kicker">電話の前によくあるご質問</p>
          <h2 id="faq-title">よくある質問</h2>
          <p>車検証が手元にない場合も、まずはご相談ください。</p>
        </div>
        <div className="faq__items">
          {faqItems.map((item, index) => (
            <details data-testid="faq-item" key={item.question} open={index === 0}>
              <summary>
                <span aria-hidden="true">Q</span>
                {item.question}
              </summary>
              <div className="faq__answer">
                <span aria-hidden="true">A</span>
                <p>{item.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
